import { Avatar } from "antd";
import "./styles.less";

export default Avatar;
